<script setup lang="ts">
/**
 * FW-145 tur 2 — design/current/Auth v2.dc.html satir 35:
 * ./brand/logo-mark-cobalt.svg (kaynak: design/brand/logo-mark-cobalt.svg,
 * 200x58 viewBox, 4 beyaz yol + kobalt zemin). Onceden AuthWelcomePanel.vue
 * bu markayi duz "FW" METNI olarak render ediyordu (koordinator bulgusu).
 *
 * Ayri bilesene alindi (AuthWelcomePanel.vue yerine) cunku SVG yol verisi
 * tek basina `vue/max-lines-per-block` sinirini (template icin 100 satir)
 * asiyordu — ayni gerekce AuthWelcomePanel.vue'nun kendi basligindaki
 * welcome/* bolunmesiyle birebir.
 *
 * Boyutlandirma tasarimin KENDI teknigiyle birebir: SVG 62x18 sabit
 * boyutta render edilir, 34x34 (parent .fw-auth-welcome__mark, bu
 * bilesenin DISINDA kalir) overflow:hidden kutusu icinde ortalanip
 * kirpilir — object-fit:cover'in bir <img> ile yaptigi ayni kirpma,
 * burada sabit width/height'li inline <svg> ile birebir tekrarlanir.
 */
</script>

<template>
  <svg
    width="62"
    height="18"
    viewBox="0 0 200 58"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <g transform="translate(29.1,5.0) scale(0.10148) translate(-324,-699)">
      <path
        fill="#fff"
        d="M 1062.95 699.819 C 1063.54 699.842 1064.62 700.24 1065.25 700.43 C 1065.84 705.986 1062.64 727.665 1061.77 734.569 L 1053.93 798.345 L 1037.9 939.717 C 1034.92 964.627 1031.81 992.457 1027.31 1016.99 C 1047.96 991.368 1074.49 951.537 1093.35 924.126 L 1180.83 798.005 C 1198.59 772.334 1217.75 741.643 1238.16 718.292 C 1240.15 716.01 1246.94 710.31 1249.7 709.966 C 1264.28 708.147 1282.85 708.848 1297.54 708.862 L 1393.54 708.993 C 1385.91 722.518 1369.42 744.067 1360 757.676 L 1273.13 881.446 C 1235.75 936.455 1196.26 990.471 1158.89 1045.56 C 1136.6 1078.41 1114.94 1111.19 1090.92 1142.9 C 1061.75 1181.41 1019.31 1170.54 977.364 1172.02 C 955.002 1171.83 932.505 1172.88 910.164 1172.23 C 892.47 1171.72 889.087 1164.35 890.266 1148.35 C 891.974 1125.17 894.73 1102.34 897.244 1079.31 L 908.731 974.229 C 911.596 948.792 914.537 911.057 920.281 886.29 C 921.136 882.605 935.165 862.89 938.399 858.277 C 949.161 842.951 960.016 827.689 970.961 812.493 L 1013.58 752.722 C 1026.26 735.024 1042.78 708.144 1062.95 699.819 z"
      />
      <path
        fill="#fff"
        d="M 1579.77 709.294 C 1624.55 707.785 1676.66 708.99 1722 709.005 C 1715.16 721.263 1695.83 746.472 1687.04 759.479 L 1582.37 911.343 C 1547.03 963.623 1511.27 1015.62 1475.09 1067.32 L 1443.68 1113.19 C 1437.66 1121.92 1429.58 1134.39 1422.16 1142.23 C 1384.76 1181.8 1326.09 1170.43 1277.34 1172 C 1265.47 1172.39 1253.59 1172.45 1241.88 1171.65 C 1231.76 1171.12 1225.51 1163.9 1225.89 1153.77 C 1226.83 1128.59 1230.88 1101.16 1233.6 1076.14 C 1237.53 1045.02 1238.17 1004.78 1245.58 975.103 C 1246.89 969.869 1269.04 941.514 1274.17 934.235 L 1327.42 859.149 C 1341.38 839.078 1355.38 818.014 1371.07 799.218 C 1377.04 792.056 1380.93 789.576 1389.21 786.055 C 1384.95 810.017 1382.38 838.966 1379.73 863.505 L 1364.58 1011.03 C 1409.05 940.28 1459.46 870.866 1506.24 801.378 L 1544.23 745.114 C 1554.35 730.179 1561.36 713.045 1579.77 709.294 z"
      />
      <path
        fill="#fff"
        d="M 672.087 902.484 C 741.222 901.913 810.36 901.789 879.497 902.112 C 863.519 929.03 840.324 955.625 823.122 982.11 C 812.851 997.923 800.926 1013.56 790.044 1029.02 C 784.894 1036.33 779.052 1037.8 770.325 1038.85 C 757.678 1039.56 744.473 1039.22 731.798 1039.23 L 658.731 1039.26 C 651.466 1039.26 643.308 1038.8 636.147 1039.28 C 608.249 1041.16 583.159 1031.86 564.593 1058.08 C 544.435 1086.56 525.67 1114.7 506.54 1143.47 C 500.928 1152.2 491.523 1169.62 481.154 1170.88 C 464.5 1172.9 445.358 1172.14 428.467 1172.12 L 324.619 1172.01 C 358.035 1123.53 391.096 1074.79 423.801 1025.82 C 440.796 1000.27 467.243 957.623 487.127 935.733 C 517.606 902.18 565.516 902.97 606.911 902.869 L 672.087 902.484 z"
      />
      <path
        fill="#fff"
        d="M 696.699 709.423 C 732.286 708.213 771.586 708.986 807.414 708.964 L 1006.19 708.868 C 985.585 737.332 965.248 765.988 945.18 794.833 C 935.243 809.022 921.573 829.646 910.443 842.41 C 902.985 850.964 863.89 848.324 851.364 848.223 L 540.424 848.027 C 552.14 830.777 564.902 814.005 576.66 796.973 C 594.133 771.663 606.588 746.385 633.559 729.606 C 654.14 716.802 672.594 711.16 696.699 709.423 z"
      />
    </g>
  </svg>
</template>

<style scoped>
svg {
  width: 62px;
  height: 18px;
  display: block;
  flex: none;
}
</style>
